module.exports = __webpack_public_path__ + "static/media/medanos.33daf51c.jpg";